import React, { useEffect } from 'react';
import ModalBase from 'react-modal';
import _ from 'lodash';
import { useRecoilValue, useRecoilCallback } from 'recoil';
import { modalSelector } from '../stores/modal/selectors';

const Modal = () => {
    const { isOpen, content, shouldCloseOnOverlayClick } = useRecoilValue(modalSelector);
    const onAfterClose = useRecoilCallback(({ snapshot }) => async () => {
        const { onClose } = await snapshot.getPromise(modalSelector);
        if (_.isFunction(onClose)) {
            onClose();
        }
    });

    useEffect(() => {
        ModalBase.setAppElement(document.querySelector('body'));
    }, []);

    return (
        <ModalBase
            isOpen={isOpen}
            onAfterClose={onAfterClose}
            shouldCloseOnOverlayClick={shouldCloseOnOverlayClick ? true : false}
            className={'modal'}
            overlayClassName={'overlay'}
        >
            {content}
        </ModalBase>
    );
};

export default Modal;
